import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';
import { T_IntegrationType } from './user.schema';

const UserInteractionSchema = new mongoose.Schema({
  emails: {
    type: [String],
    required: true,
  },
  interactionType: { type: String, required: true },
  reference: { type: String, unique: true },
  description: { type: String },
  created: { type: Date, default: Date.now() },
});

export type T_UserInteractionBase = InferSchemaType<typeof UserInteractionSchema>;

// Extend the type to provide proper typing for interactionType
export interface T_UserInteraction extends Omit<T_UserInteractionBase, 'interactionType'> {
  interactionType: T_IntegrationType;
  created: Date;
}

export type T_UserInteractionDocument = T_UserInteraction &
  Document & {
    _id: string;
  };

export { UserInteractionSchema };
